/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'WIDGETS_LOADED',
]);



// WEBPACK FOOTER //
// ./src/settings/constants/WidgetConstants.js